
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        {/* Top Section - Logo */}
        <div className="footer-top-border d-flex justify-content-start align-items-center pb-4 mb-4 mb-lg-5">
          <img
            src="/assets/images/logo/cashkaro.png"
            alt="logo"
            className="footer-logo"
          />
        </div>

        {/* Footer Content */}
        <div className="row pb-4 pb-lg-5">
          {/* Column 1 */}
          <div className="col-12 col-lg-3 mb-4">
            <h3 className="fw-bold mb-3 mb-lg-4">Quick Links</h3>
            <p className="footer-text">
              Subscribe our newsletter to get our latest update & news
            </p>

            <h6 className="footer-subtitle">Let's Get Social</h6>
            <div className="d-flex flex-wrap gap-3 mb-2">
              <a href="#" className="footer-social"><i className="lab la-facebook-f"></i></a>
              <a href="#" className="footer-social"><i className="lab la-twitter"></i></a>
              <a href="#" className="footer-social"><i className="lab la-instagram"></i></a>
              <a href="#" className="footer-social"><i className="lab la-youtube"></i></a>
              <a href="#" className="footer-social"><i className="lab la-linkedin-in"></i></a>
            </div>
          </div>

          {/* About CashKaroNa */}
          <div className="col-6 col-md-3 col-lg-2 mb-4">
            <h3 className="fw-bold mb-3 mb-lg-4">About CashKaroNa</h3>
            <ul className="list-unstyled">
              <li className="mb-3"><Link to="/aboutus" className="footer-link">About Us</Link></li>
              <li className="mb-3"><Link to="/testimonials" className="footer-link">Testimonials</Link></li>
            </ul>
          </div>

          {/* Useful Reads */}
          <div className="col-6 col-md-3 col-lg-2 mb-4">
            <h3 className="fw-bold mb-3 mb-lg-4">Useful Reads</h3>
            <ul className="list-unstyled">
              <li className="mb-3"><Link to="/terms-conditions" className="footer-link">Terms and Conditions</Link></li>
              <li className="mb-3"><Link to="/privacy-policy" className="footer-link">Privacy & Cookie Policy</Link></li>
            </ul>
          </div>

          {/* Special Pages */}
          <div className="col-6 col-md-3 col-lg-2 mb-4">
            <h3 className="fw-bold mb-3 mb-lg-4">Special Pages</h3>
            <ul className="list-unstyled">
              <li className="mb-3 footer-link">Refer and Earn</li>
            </ul>
          </div>

          {/* Connect With Us */}
          <div className="col-6 col-md-3 col-lg-3 mb-4">
            <h3 className="fw-bold mb-3 mb-lg-4">Connect With Us</h3>
            <ul className="list-unstyled">
              <li className="mb-3"><Link to="/help" className="footer-link">Help</Link></li>
              <li className="mb-3 footer-link">Contact Us</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="row align-items-center py-3 py-lg-4 footer-bottom-border">
          <div className="col-12 text-center">
            Copyright © 2026 <span className="footer-highlight">CashKaroNa</span>. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}


export default Footer;
